export default __webpack_public_path__ + "static/media/landscape20.2dfd4276.jpeg";